import React from 'react';
import { X } from 'lucide-react';
import {
  REJECT_VOD_MODAL_BODY,
  REJECT_VOD_MODAL_CANCEL,
  REJECT_VOD_MODAL_CONFIRM,
  REJECT_VOD_MODAL_TITLE,
} from '../commissionerReviewCopy';

interface RejectVodConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  rejecting: boolean;
}

const RejectVodConfirmModal: React.FC<RejectVodConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
  rejecting,
}) => {
  if (!open) return null;

  const handleConfirm = async () => {
    await onConfirm();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="reject-vod-modal-title"
      data-testid="reject-vod-confirm-modal"
    >
      <div className="card max-w-md w-full relative">
        <button
          type="button"
          onClick={onClose}
          className="absolute top-4 right-4 text-secondary-400 hover:text-white"
          aria-label="Close"
          disabled={rejecting}
        >
          <X className="h-5 w-5" />
        </button>
        <h2 id="reject-vod-modal-title" className="text-lg font-semibold text-white mb-2">
          {REJECT_VOD_MODAL_TITLE}
        </h2>
        <p className="text-sm text-secondary-400 mb-6" data-testid="reject-vod-modal-body">
          {REJECT_VOD_MODAL_BODY}
        </p>
        <div className="flex gap-3 justify-end">
          <button
            type="button"
            className="btn-secondary"
            onClick={onClose}
            disabled={rejecting}
            data-testid="reject-vod-cancel-button"
          >
            {REJECT_VOD_MODAL_CANCEL}
          </button>
          <button
            type="button"
            className="btn-secondary text-red-300 border-red-800 hover:bg-red-900/30"
            onClick={() => void handleConfirm()}
            disabled={rejecting}
            data-testid="reject-vod-confirm-button"
          >
            {rejecting ? 'Rejecting...' : REJECT_VOD_MODAL_CONFIRM}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectVodConfirmModal;
